export const ParamTypes = {
    AMOUNT: "AMOUNT",
    WEIGHT: "WEIGHT",
    TIME: "TIME",
    DAYS: "DAYS",
    ANIMAL: "ANIMAL",
    REASON: "REASON",
    AGE: "AGE",
    RESULT: "RESULT",
    BOOLEAN: "BOOLEAN",
    PARTURITION_LEVEL: "PARTURITION_LEVEL",
    INDEX: "INDEX",
    PERCENT: "PERCENT",
    PRICE: "PRICE",
    TECHNOLOGY_GROUP_REMOVAL: "TECHNOLOGY_GROUP_REMOVAL",
    SECTOR_TYPE: "SECTOR_TYPE",
    SOW_STATE: "SOW_STATE",
    LOCATION: "LOCATION",
    WEEK_DAY: "WEEK_DAY",
    DICTIONARY: "DICTIONARY",
    MEDICINE: "MEDICINE",
    RACE: "RACE",
    USER: "USER",
    RACE_CODE: "RACE_CODE",
    GROUP_NR: "GROUP_NR",
    MONTH: "MONTH",
    TATTOO: "TATTOO",
    RFID: "RFID",
    HERD_NUMBER: "HERD_NUMBER",
    SUPPLIER: "SUPPLIER",
    ANIMAL_KIND: "ANIMAL_KIND",
    REMOVED_REASONS: "REMOVED_REASONS",
    SELL_REASON: "SELL_REASON",
    SELECTION_REASON: "SELECTION_REASON",
    DATE: "DATE",
};
